import styled from 'styled-components';

export const StyledRequirementsContent = styled.div`
    font-family: 'Poppins';
    line-height: 1.4em;
    font-size: 18px;
`;
